export const ad_departamento_estado = (departamentos) =>{

    let arr = []
    for (let i = 0 ; i<departamentos.length;i++){
        let dep = departamentos[i]

        arr.push({nombre: dep, color: '#33993F'})
    }

    return arr

}